import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-suscribite-dialog',
  templateUrl: './suscribite-dialog.component.html',
  styleUrls: ['./suscribite-dialog.component.scss']
})
export class SuscribiteDialogComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
